import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import messages from './messages';
import Button from '../../components/button/index';
import Assign from '../../components/assign/index';
import { generateStudentTeacherAssignList, generateClassroomAssignList } from '../../helpers/utils';

class AssignUser extends Component {
    constructor(props) {
        super(props);
        this.list = { assignData: [], unassignData: [] };
        this.listObject = {
            groups: [],
            isExpandable: false,
            info: {
                additionalInfo: [],
                badgeContent: '',
                badgeStyle: ''
            },
            child: {
                data: [],
                isMultiSelect: false
            }
        };
    }

    renderHtmlElements = () => {
        const unassignedList = [];
        const assignedList = [];
        const { type, data, selectedYearGroup } = this.props;

        switch (type) {
        case 'student':
        case 'teacher':
            if (data) {
                for (const classroom of data) {
                    if (classroom.isAssigned) {
                        assignedList.push(classroom);
                    } else {
                        unassignedList.push(classroom);
                    }
                }
                this.list = generateStudentTeacherAssignList(assignedList,
                    unassignedList,
                    selectedYearGroup,
                    type,
                    this.listObject);
            }
            break;
        default: if (data) {
            this.list = generateClassroomAssignList(data, this.listObject);
            break;
        }
        }
    }

    handleOnChildSelection = (itemId, groups) => {
        this.props.handleOnChildSelection(itemId, groups);
    };

    handleOnYearGroupSelection = (name, val) => {
        this.setState({ selectedYearGroup: val });
        this.props.handleOnYearGroupSelection(name, val);
    }

    handleOnClassroomSelection = (id) => {
        this.props.handleOnClassroomSelection(parseInt(id, 10));
    }

    handleOnAssignItem = (assignedListItemIds) => {
        this.props.handleOnAssignItem(assignedListItemIds);
    }

    handleOnUnAssignItem = (unAssignedListItemIds) => {
        this.props.handleOnUnAssignItem(unAssignedListItemIds);
    }

    closeHandler = () => {
        this.props.handleOnClose();
    }

    saveHandler = () => {
        this.setState({
            enableForwardButton: false,
            enableBackButton: false
        });

        this.props.handleOnSave();
    }

    render() {
        this.renderHtmlElements();
        const { intl, header, selectedYearGroup, type, yearGroups,
            disableAssignCancelButton, disableAssignSaveButton, isSaveInProgress } = this.props;
        const pageHeading = type === 'class' ? `${intl.formatMessage(messages.assignedTeachers)} ` :
            `${intl.formatMessage(messages.assignedClasses)} `;
        return (<div className={css.assignContainer}>
            <div className={css.mainHeader}>
                {pageHeading}
                <span
                    className={css.headerDescription}>
                    {header}
                </span>
            </div>
            <Assign
                handleOnAssignItem={this.handleOnAssignItem}
                handleOnChildSelection={this.handleOnChildSelection}
                handleOnClassroomSelection={this.handleOnClassroomSelection}
                handleOnSearchClick={this.props.handleOnSearchClick}
                handleOnUnAssignItem={this.handleOnUnAssignItem}
                handleOnYearGroupSelection={this.handleOnYearGroupSelection}
                header={header}
                isSaveInProgress={isSaveInProgress}
                leftList={this.list.unassignData}
                rightList={this.list.assignData}
                selectedYearGroup={selectedYearGroup}
                type={type}
                yearGroups={yearGroups}
            />
            <div className={css.assignFooter}>
                <Button
                    containerClassName={css.cancelButton}
                    disabled={disableAssignCancelButton}
                    handleOnClick={this.closeHandler}
                    label={intl.formatMessage(messages.cancel)} />
                <Button
                    containerClassName={css.saveButton}
                    disabled={disableAssignSaveButton}
                    handleOnClick={this.saveHandler}
                    label={intl.formatMessage(messages.save)}
                />
            </div>
        </div>);
    }
}

AssignUser.propTypes = {
    header: PropTypes.string,
    data: PropTypes.array,
    type: PropTypes.string,
    intl: intlShape.isRequired,
    yearGroups: PropTypes.array,
    isSaveInProgress: PropTypes.bool,
    selectedYearGroup: PropTypes.string,
    handleOnClassroomSelection: PropTypes.func,
    handleOnChildSelection: PropTypes.func,
    handleOnYearGroupSelection: PropTypes.func,
    disableAssignSaveButton: PropTypes.bool,
    disableAssignCancelButton: PropTypes.bool,
    handleOnClose: PropTypes.func,
    handleOnSave: PropTypes.func,
    handleOnSearchClick: PropTypes.func,
    handleOnAssignItem: PropTypes.func,
    handleOnUnAssignItem: PropTypes.func
};

export default injectIntl(styleable(css)(AssignUser));



// WEBPACK FOOTER //
// ./app/components/assign-user/index.js